import { render, staticRenderFns } from "./SpaceChallengeBoxWrapper.vue?vue&type=template&id=0bc648f9&scoped=true"
import script from "./SpaceChallengeBoxWrapper.vue?vue&type=script&lang=js"
export * from "./SpaceChallengeBoxWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc648f9",
  null
  
)

export default component.exports